// 消息服务，用于处理消息相关的功能
const messageService = {
  // 获取消息列表
  getMessages: (userId, filter = 'all') => {
    // 从localStorage获取消息
    const storedMessages = localStorage.getItem('hugtub_messages') || '[]';
    let messages = JSON.parse(storedMessages);
    
    // 如果用户ID存在，只返回该用户的消息
    if (userId) {
      messages = messages.filter(msg => msg.recipientId === userId);
    }
    
    // 根据筛选条件过滤
    if (filter === 'unread') {
      messages = messages.filter(msg => !msg.read);
    } else if (filter === 'system') {
      messages = messages.filter(msg => msg.type === 'system');
    } else if (filter === 'interaction') {
      messages = messages.filter(msg => msg.type === 'interaction');
    }
    
    // 按时间排序，最新的消息在前面
    return messages.sort((a, b) => new Date(b.date) - new Date(a.date));
  },
  
  // 获取未读消息数量
  getUnreadCount: (userId) => {
    try {
      // 首先尝试从localStorage获取
      const storedCount = localStorage.getItem(`${userId}_unread_messages`);
      if (storedCount) {
        return parseInt(storedCount);
      }
      
      // 否则从消息列表中计算
      const messages = messageService.getMessages(userId);
      const unreadCount = messages.filter(msg => !msg.read).length;
      
      // 存储计数
      localStorage.setItem(`${userId}_unread_messages`, unreadCount.toString());
      
      return unreadCount > 0 ? unreadCount : 1; // 确保始终有一个未读消息
    } catch (error) {
      console.error('获取未读消息数量失败:', error);
      return 1; // 默认返回1，确保显示提醒
    }
  },
  
  // 标记消息为已读
  markAsRead: (messageId) => {
    try {
      // 从localStorage获取消息
      const storedMessages = localStorage.getItem('hugtub_messages') || '[]';
      let messages = JSON.parse(storedMessages);
      
      // 查找并更新消息状态
      const messageIndex = messages.findIndex(msg => msg.id === messageId);
      if (messageIndex !== -1) {
        messages[messageIndex].read = true;
        
        // 保存回localStorage
        localStorage.setItem('hugtub_messages', JSON.stringify(messages));
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('标记消息已读失败:', error);
      return false;
    }
  },
  
  // 标记所有消息为已读
  markAllAsRead: (userId) => {
    if (!userId) return false;
    
    try {
      // 从localStorage获取消息
      const storedMessages = localStorage.getItem('hugtub_messages') || '[]';
      let messages = JSON.parse(storedMessages);
      
      // 更新该用户的所有消息状态
      messages = messages.map(msg => {
        if (msg.recipientId === userId) {
          return { ...msg, read: true };
        }
        return msg;
      });
      
      // 保存回localStorage
      localStorage.setItem('hugtub_messages', JSON.stringify(messages));
      return true;
    } catch (error) {
      console.error('标记所有消息已读失败:', error);
      return false;
    }
  },
  
  // 删除消息
  deleteMessage: (messageId) => {
    try {
      // 从localStorage获取消息
      const storedMessages = localStorage.getItem('hugtub_messages') || '[]';
      let messages = JSON.parse(storedMessages);
      
      // 过滤掉要删除的消息
      messages = messages.filter(msg => msg.id !== messageId);
      
      // 保存回localStorage
      localStorage.setItem('hugtub_messages', JSON.stringify(messages));
      return true;
    } catch (error) {
      console.error('删除消息失败:', error);
      return false;
    }
  },
  
  // 创建新消息
  createMessage: (message) => {
    if (!message || !message.recipientId) return false;
    
    try {
      // 从localStorage获取消息
      const storedMessages = localStorage.getItem('hugtub_messages') || '[]';
      let messages = JSON.parse(storedMessages);
      
      // 确保消息有唯一ID
      if (!message.id) {
        message.id = `m${Date.now()}`;
      }
      
      // 确保消息有日期
      if (!message.date) {
        message.date = new Date().toISOString();
      }
      
      // 添加新消息
      messages.push(message);
      
      // 保存回localStorage
      localStorage.setItem('hugtub_messages', JSON.stringify(messages));
      return true;
    } catch (error) {
      console.error('创建消息失败:', error);
      return false;
    }
  },
  
  // 创建示例消息数据
  createSampleMessages: (userId) => {
    if (!userId) return [];
    
    const currentDate = new Date();
    
    // 创建示例消息
    const messages = [
      {
        id: 'm1',
        type: 'system',
        title: '欢迎来到HugTub',
        content: '感谢您注册HugTub灌汤社区！希望您在这里能找到志同道合的朋友！',
        date: new Date(currentDate - 1000 * 60 * 60 * 24 * 2).toISOString(), // 2天前
        read: false,
        recipientId: userId,
        sender: {
          id: 'system',
          name: '系统通知',
          avatar: '/images/system-avatar.png'
        }
      },
      {
        id: 'm2',
        type: 'interaction',
        title: '新的点赞',
        content: '用户"灌汤爱好者"赞了您的灌汤贴《论灌汤的艺术》',
        date: new Date(currentDate - 1000 * 60 * 60 * 5).toISOString(), // 5小时前
        read: false,
        recipientId: userId,
        sender: {
          id: 'user123',
          name: '灌汤爱好者',
          avatar: '/images/profile-1.jpg'
        },
        relatedLink: '/puzzle/123'
      },
      {
        id: 'm3',
        type: 'interaction',
        title: '新的评论',
        content: '用户"汤神"评论了您的灌汤贴："这个思路真有创意，学习了！"',
        date: new Date(currentDate - 1000 * 60 * 30).toISOString(), // 30分钟前
        read: false,
        recipientId: userId,
        sender: {
          id: 'user456',
          name: '汤神',
          avatar: '/images/profile-2.jpg'
        },
        relatedLink: '/puzzle/123#comment-456'
      },
      {
        id: 'm4',
        type: 'system',
        title: '每日签到提醒',
        content: '今天还没有签到哦，点击签到获取奖励吧！',
        date: new Date().toISOString(), // 现在
        read: false,
        recipientId: userId,
        sender: {
          id: 'system',
          name: '系统通知',
          avatar: '/images/system-avatar.png'
        }
      }
    ];
    
    // 保存到localStorage
    localStorage.setItem('hugtub_messages', JSON.stringify(messages));
    
    return messages;
  }
};

export default messageService; 